import axios from 'axios';
import * as queryString from "query-string";
import {API_URL} from "../config/constant";

export const userService = {
    async register(data) {
        return axios({
            method: 'POST',
            url: `${API_URL}/live/broker/add`,
            data: queryString.stringify(data)
        })
            .then(function (response) {
                return response.data
            }).catch((e) => {
                return e.response.data
            });
    },
};
